import { Button, IconButton, Typography } from "@mui/material"
import { GridActionsCellItem } from "@mui/x-data-grid"
import { expenseJobOrderColNm } from "constants/expenseJobOrderConstant"
import { subcontractExpenseColNm, whtPayrTypOptions } from "constants/subcontractConstant"
import { renderEditCellAutocomplete } from "components/DataGridCellExpand/renderEditCellAutocomplete"
import dayjs from "dayjs"
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { numberFormat } from "utils";
import { getPOIPlace } from "utils/getPOIPlace";
import { BoxFR } from "components/BoxCustom";
import { RemoveCircleRounded, SwapHorizRounded } from "resource/muiImport";

export const searchColumnsFullJob= [
  
  {
    field: "FinDte",
    headerName: "วิ่งจบ",
    width: 100,
    type: "dateTime",
    valueGetter: (params) => params.value && dayjs(params.value),
    valueFormatter: (params)=> params.value? params.value.format("DD/MM HH:mm"): "-",
  },
  {
    field: "CusSNm",
    headerName: "ลูกค้า",
    flex: 2,
  },
  {
    field: "JobSNm",
    headerName: "งาน",
    flex: 2,
  },
  {
    field: "JobNo",
    headerName: expenseJobOrderColNm.JobNo,
    flex: 3,
    renderCell: (params) => {
      return (
        <Button fullWidth sx={{ height:30}} variant={params.value?"contained": "outlined"} >{params.value}</Button>
      )
    },
  },
]
export const searchColumns= [
  
  {
    field: "FinDte",
    headerName: "วิ่งจบ",
    width: 100,
    type: "dateTime",
    valueGetter: (params) => params.value && dayjs(params.value),
    valueFormatter: (params)=> params.value? params.value.format("DD/MM HH:mm"): "-",
  },
  {
    field: "CusSNm",
    headerName: "ลูกค้า",
    flex: 1,
  },
  {
    field: "JobSNm",
    headerName: "งาน",
    flex: 1,
  },
  {
    field: "JobOrdId",
    headerName: expenseJobOrderColNm.JobOrdId,
    width: 100,
    renderCell: (params) => {
      return (
        params.value?
        <Button fullWidth sx={{ height:30}} variant={params.value?"contained": "outlined"} >{params.value}</Button>
        :
        ""
      )
    },
  },
  {
    field: "ContNo",
    headerName: expenseJobOrderColNm.ContNo,
    width: 120,
  },
  {
    field: "JobNo",
    headerName: expenseJobOrderColNm.JobNo,
    flex: 1,
    renderCell: (params) => {
      return (
        <Button fullWidth sx={{ height:30}} variant={params.value?"contained": "outlined"} >{params.value}</Button>
      )
    },
  },
]

export const selectedColumns= (handleDeleteRow)=>[
  {
    field: "JobOrdId",
    headerName: expenseJobOrderColNm.JobOrdId,
    width: 100,
    align: "center"
  },
  {
    field: "JobNo",
    headerName: expenseJobOrderColNm.JobNo,
    flex: 1,
  },
  {
    field: "Bkg",
    headerName: expenseJobOrderColNm.Bkg,
    flex: 1,
  },
  // {
  //   field: "AptTm",
  //   headerName: "เวลานัด",
  //   width: 100,
  //   type: "dateTime",
  //   valueGetter: (params) => params.value && dayjs(params.value),
  //   valueFormatter: (params)=> params.value? params.value.format("DD/MM HH:mm"): "-",
  // },
  {
    field: "ContNo",
    headerName: expenseJobOrderColNm.ContNo,
    width: 120,
  },
  {
    field: "TlrTyp",
    headerName: "หาง",
    width: 80,
  },
  {
    field: "ContSizeFull",
    headerName: "ขนาด",
    width: 70,
  },
  {
    field: "TakePlc",
    headerName: "รับ",
    valueGetter: (params) => getPOIPlace(params.row, "TAKE"),
    width: 70,
  },
  {
    field: "Loc",
    headerName: "ส่ง",
    valueGetter: (params) => getPOIPlace(params.row, "LOC"),
    width: 120,
  },
  {
    field: "RtnPlc",
    headerName: "คืน",
    valueGetter: (params) => getPOIPlace(params.row, "RTN"),
    width: 70,
  },
  {
    field: "FinDte",
    headerName: expenseJobOrderColNm.FinDte,
    width: 100,
    type: "dateTime",
    valueGetter: (params) => params.value && dayjs(params.value),
    valueFormatter: (params)=> params.value? params.value.format("DD/MM HH:mm"): "-",
  },
  {
    field: "actions",
    type: "actions",
    width: 30,
    getActions: (params) => [
      <GridActionsCellItem
        icon={<RemoveCircleIcon />}
        label="Delete"
        onClick={() => handleDeleteRow(params.row)}
      />
    ] ,
  }
]

export const expenseColumn = (onInvoiceClick, handleDeleteExpenseRow) =>[
  {
    field: "IsCost",
    headerName: "ประเภท",
    width: 80,
    cellClassName: (params) => params.value==null?null: params.value === 1 ? "isCost" : "isExp",
    valueFormatter: (params)=> params.value==null?null: params.value === 1 ? `ต้นทุน`:`รายได้`,
  },
  {
    field: "ExpNm",
    headerName: expenseJobOrderColNm.ExpNm,
    width: 160,
  },
  {
    field: "UntPr",
    headerName: expenseJobOrderColNm.UntPr,
    width: 100,
    align: "right",
    valueFormatter: (params) => params.value? numberFormat(params.value): " "
  },
  {
    field: "Qty",
    headerName: expenseJobOrderColNm.Qty,
    width: 80,
    align: "center",
  },
  {
    field: "Total",
    headerName: expenseJobOrderColNm.Total,
    width: 100,
    align: "right",
    valueFormatter: (params) => params.value? numberFormat(params.value): " "
  },
  {
    field: "VatPrct",
    headerName: expenseJobOrderColNm.VatPrct,
    width: 70,
    align: "right",
    valueFormatter: (params) => {
      return params.value?`${params.value}%`:" ";
    }
  },
  {
    field: "WhtPrct",
    headerName: expenseJobOrderColNm.WhtPrct,
    width: 60,
    align: "right",
    valueFormatter: (params) => {
      return params.value?`${params.value}%`:" ";
    }
  },
  {
    field: "IsOwnRcpt",
    headerName: expenseJobOrderColNm.IsOwnRcpt,
    width: 120,
    align: "center",
    valueFormatter: (params) => {
      return params.value === null || params.id <= 0?"": params.value === 1?`ใบเสร็จบริษัท`:`ใบเสร็จลูกค้า`;
    },
  },
  {
    field: "Rmk",
    headerName: expenseJobOrderColNm.Rmk,
    flex:1
  },
  {
    field: "InvNo",
    headerName: expenseJobOrderColNm.InvNo,
    width: 150,
    renderCell: (params) => {
      return (
        params.value &&
        <Button 
        fullWidth sx={{ height:30}} 
        variant={params.value?"contained": "outlined"} 
        onClick={()=>onInvoiceClick(params.row.InvId)}>{params.value}</Button>
      )
    },
  },
  {
    field: "actions",
    type: "actions",
    width: 30,
    getActions: (params) => params.id>0? [
      <GridActionsCellItem
        icon={<RemoveCircleIcon />}
        label="Delete"
        onClick={() => handleDeleteExpenseRow(params.row)}
      />
    ]: [] ,
  }
]

export const invoiceExpenseColumns = (handleDeleteRow)=>[
  {
    field: "JobOrdId",
    headerName: expenseJobOrderColNm.JobOrdId,
    width: 100,
    align: "center"
  },
  {
    field: "ExpNm",
    headerName: expenseJobOrderColNm.ExpNm,
    width: 200,
  },
  {
    field: "Total",
    headerName: expenseJobOrderColNm.Total,
    width: 100,
    align: "right"
  },
  {
    field: "Rmk",
    headerName: expenseJobOrderColNm.Rmk,
    flex:1
  },
  {
    field: "actions",
    type: "actions",
    width: 30,
    getActions: (params) => [
      <GridActionsCellItem
        icon={<RemoveCircleIcon />}
        label="Delete"
        onClick={() => handleDeleteRow(params.row.id)}
      />
    ] ,
  }
]

export const addExpTableColumns = ({handleChangeIsOwnRcpt, handleRemoveRow, whtTypeCombo = [], supplierCombo = []}) => [
  {
    field: "No",
    headerName: "No.",
    width: 40,
    align: "center"
  },
  {
    field: "IsOwnRcpt",
    headerName: expenseJobOrderColNm.IsOwnRcpt,
    width: 100,
    cellClassName: (params) => params.id === 0? null: params.value === 1 ? "ownRcpt" : "cusRcpt",
    renderCell: ({ id, value, row }) => id === 0 ? null : (
      <BoxFR>
        <Typography variant="body2">{row.IsCost === 1 ? "-"
          : value === 1 ? "บริษัท" : value === 0 ? "ลูกค้า" : "-"}</Typography>
        {
          row.IsCost === 1 ? null :
            <IconButton color="primary" onClick={() => handleChangeIsOwnRcpt(id)}>
              <SwapHorizRounded />
            </IconButton>
        }
      </BoxFR>
    )
  },
  {
    field: "ExpNm",
    headerName: expenseJobOrderColNm.ExpNm,
    flex: 1,
    valueGetter: (params) => params.value || "-"
  },
  {
    field: "VatPrct",
    type: "number",
    headerName: expenseJobOrderColNm.VatPrct,
    width: 40,
    valueGetter: ({ value, id }) => id === 0 ? "" : `${value || 0}%`,
    align: "right",
    editable: true,
  },
  {
    field: "UntPrB4Vat",
    type: "number",
    headerName: "ยอดก่อน Vat",
    UntPr: "จำนวนเงิน",
    width: 90,
    align: "right",
    editable: true,
    valueFormatter: ({ value }) => value ? numberFormat(value) : "0.00"
  },
  {
    field: "UntPr",
    type: "number",
    headerName: expenseJobOrderColNm.UntPr,
    width: 90,
    align: "right",
    editable: true,
    valueFormatter: ({ value }) => value ? numberFormat(value) : "0.00"
  },
  {
    field: "WhtPrct",
    type: "number",
    headerName: expenseJobOrderColNm.WhtPrct,
    width: 40,
    valueGetter: ({ value, id }) => id === 0 ? "" : `${value || 0}%`,
    align: "right",
    editable: true,
  },
  {
    field: "WhtPayrTyp",
    headerName: subcontractExpenseColNm.WhtPayrTyp,
    width: 110,
    type: "singleSelect",
    valueOptions: whtPayrTypOptions,
    valueGetter: ({ value }) => whtPayrTypOptions.find(v => v.value === value)?.label || "",
    editable: true,
  },
  {
    field: "WhtTypId",
    headerName: subcontractExpenseColNm.WhtTypId,
    width: 90,
    type: "singleSelect",
    valueOptions: whtTypeCombo.map(v => ({ value: v.id, label: v.label })),
    valueGetter: ({ value }) => whtTypeCombo.find(v => v.id === value)?.label || "",
    editable: true,
  },
  {
    field: "SupId",
    headerName: subcontractExpenseColNm.SupId,
    width: 100,
    valueFormatter: ({ value }) => supplierCombo.find(v => v.id === value)?.label || "",
    renderEditCell: renderEditCellAutocomplete(supplierCombo),
    editable: true,
  },
  {
    field: "DocDte",
    headerName: subcontractExpenseColNm.DocDte,
    width: 110,
    type: "date",
    valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM/YYYY") : "-",
    editable: true,
  },
  {
    field: "Qty",
    type: "number",
    headerName: expenseJobOrderColNm.Qty,
    width: 60,
    align: "center",
    editable: true,
  },
  {
    field: "Total",
    headerName: expenseJobOrderColNm.Total,
    width: 90,
    align: "right",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "0.00"
  },
  {
    field: "Rmk",
    headerName: expenseJobOrderColNm.Rmk,
    flex: 1,
    editable: true,
  },
  {
    field: "actions",
    type: "actions",
    width: 25,
    minWidth: 0,
    getActions: (params) => params.id === 0 ? [] : [
      <GridActionsCellItem
        icon={<RemoveCircleRounded />}
        label="Remove"
        onClick={() => handleRemoveRow(params.row)}
      />
    ]
  },
]